import { AppConfig } from './../../../../../environments/appconfig';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MaUnidadnegocio } from '../dominio/maunidadnegocio';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class MaUnidadNegocioService {
    private url = `${this.config.getEnv('proxy')}spring/core/maunidadnegocio/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarActivos(): Promise<MaUnidadnegocio[]> {
        return this.http.get(`${this.url}listarActivos`,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as MaUnidadnegocio[];
            })
            .catch(error => []);
    }
}
